import { memo, useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

import { BannerLayout, BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';
import { Button } from 'ui-components/components/button';
import { Text, TextType } from 'ui-components/components/text';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import { PHONE_CAPTURE_SOURCE } from '../phone-number-capture/constants';
import { messages } from './messages';
import { useGlobalModalLaunchContext } from '../../contexts/modal-context/global-modal-context';
import { Segment } from '../../services/analytics-services/segment';
import { PHONE_CAPTURE_BANNER_CLICKED, PHONE_CAPTURE_BANNER_DISMISSED } from '../../constants/analytics-events';
import { UserSettings } from '../../enums/user-settings/user-settings';
import { saveUserSetting } from '../../store/user/user.actions';
import style from './header-notification-banner.module.less';

export const PhoneNumberCaptureBanner = memo(() => {
  const modalContext = useGlobalModalLaunchContext();
  const dispatch = useDispatch();
  const [isDismissed, setIsDismissed] = useState(false);

  const handleClick = useCallback(() => {
    Segment.trackEvent(PHONE_CAPTURE_BANNER_CLICKED);
    if (modalContext) {
      modalContext.openPhoneCaptureModal(PHONE_CAPTURE_SOURCE.BANNER);
    }
  }, [modalContext]);

  const handleDismiss = useCallback(() => {
    Segment.trackEvent(PHONE_CAPTURE_BANNER_DISMISSED);

    setIsDismissed(true);

    dispatch(
      saveUserSetting({
        settingName: UserSettings.phoneNumberCaptureBannerDismissed.settingName,
        settingValue: true,
        excludeV3prefix: true,
      }),
    );
  }, [dispatch]);

  if (isDismissed) {
    return null;
  }

  return (
    <BannerMessageV2
      className={style['banner-padding']}
      content={
        <Text
          formattedMessageValues={{
            a: (chunks) => (
              <Button onClick={handleClick} theme={THEME_CONSTANTS.link}>
                {chunks}
              </Button>
            ),
          }}
          textType={TextType.Paragraph}
          value={messages.phoneNumberCaptureBannerContent}
        />
      }
      layout={BannerLayout.Default}
      onClose={handleDismiss}
      status={BannerStatus.Info}
    />
  );
});

PhoneNumberCaptureBanner.displayName = 'PhoneNumberCaptureBanner';
